import { useState } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { IconButton } from "@similarweb/ui-components";

import { PDFButton } from "app/components/React/PDFButton/PDFButton";
import { EAvailabilityMode } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { getPDFCallback } from "app/UtilitiesAndConstants/UtilityFunctions/getPDF";
import { isTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";

import { StyledDashboardLoader } from "./styles";

const PDFComponent = () => {
    const { state } = useCurrentStateAndParams();
    const [isPdfLoading, setIsPdfLoading] = useState<boolean>(false);
    const isDownloadPdfHook = swSettings.current?.resources?.IsExportToPDFAllowed === EAvailabilityMode.HOOK;
    const pdfDownloadsMethod = (state as any)?.pdfDownloadsMethod as () => Promise<void>;

    const onClickDownloadPdf = getPDFCallback(setIsPdfLoading, pdfDownloadsMethod, isDownloadPdfHook);

    if (isPdfLoading) {
        return (
            <StyledDashboardLoader
                title={translate("common.pdfoverlay.generatingreport")}
                subtitle={translate("common.pdfoverlay.downloadedshortly")}
            />
        );
    }

    return isTrialOrAfterTrial() ? (
        <IconButton
            iconName="download"
            type="flat"
            onClick={onClickDownloadPdf}
        >
            {translate("trial.pdf.icon.text.vwo")}
        </IconButton>
    ) : (
        <PDFButton
            isDisabled={isPdfLoading}
            onClick={onClickDownloadPdf}
            isLocked={isDownloadPdfHook}
        />
    );
};

export default PDFComponent;
